import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { formatDateRangeForFilters } from '../utils/time';
import { CommunicationService } from '../http/communication.service';
import { AiPresenceAdvertisingImpactResponse, AiPresenceOverviewPayload, AiPresenceOverviewResponse, AiPresencePaths, AiPresenceShareOfVoiceResponse, AiPresenceTopicsTableResponse } from '../components/ai-presence-screen/types';

@Injectable({
    providedIn: 'root'
})

export class AiPresenceService {
    constructor(private communicationService: CommunicationService) { }

    getOverview(payload: AiPresenceOverviewPayload): Observable<AiPresenceOverviewResponse> {
        const options = { ...payload, ...formatDateRangeForFilters(payload) };
        return this.communicationService.httpPost<AiPresenceOverviewResponse>(AiPresencePaths.OVERVIEW, options)
            .pipe(
                catchError((error) => {
                    console.error('Error fetching messaging data', error);
                    throw error;
                })
            );
    }

    getAdvertisingImpact(payload: AiPresenceOverviewPayload): Observable<AiPresenceAdvertisingImpactResponse> {
        const options = { ...payload, ...formatDateRangeForFilters(payload) };
        return this.communicationService.httpPost<AiPresenceAdvertisingImpactResponse>(AiPresencePaths.ADVERTISING_IMPACT, options)
            .pipe(
                catchError((error) => {
                    console.error('Error fetching advertising impact data', error);
                    throw error;
                })
            );
    }

    getTopicsTable(payload: AiPresenceOverviewPayload): Observable<AiPresenceTopicsTableResponse> {
        const options = { ...payload, ...formatDateRangeForFilters(payload) };
        return this.communicationService.httpPost<AiPresenceTopicsTableResponse>(AiPresencePaths.TOPICS_TABLE, options)
            .pipe(
                catchError((error) => {
                    console.error('Error fetching topics table data', error);
                    throw error;
                })
            );
    }

    getShareOfVoice(payload: AiPresenceOverviewPayload): Observable<AiPresenceShareOfVoiceResponse> {
        const options = { ...payload, ...formatDateRangeForFilters(payload) };
        return this.communicationService.httpPost<AiPresenceShareOfVoiceResponse>(AiPresencePaths.SHARE_OF_VOICE, options)
            .pipe(
                catchError((error) => {
                    console.error('Error fetching share of voice data', error);
                    throw error;
                })
            );
    }
}